/* tslint:disable */
/* eslint-disable */
/**
 * Wire API (development)
 * The API for the Clientwire messaging service.
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@clientwire.net
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TriggerKind } from './trigger-kind';
import {
    TriggerKindFromJSON,
    TriggerKindFromJSONTyped,
    TriggerKindToJSON,
    TriggerKindToJSONTyped,
} from './trigger-kind';
import type { WorkflowAction } from './workflow-action';
import {
    WorkflowActionFromJSON,
    WorkflowActionFromJSONTyped,
    WorkflowActionToJSON,
    WorkflowActionToJSONTyped,
} from './workflow-action';

/**
 * Trigger fired when a conversation is created
 * @export
 * @interface ConversationCreatedTrigger
 */
export interface ConversationCreatedTrigger {
    /**
     * Discriminator property to identify the trigger type
     * @type {TriggerKind}
     * @memberof ConversationCreatedTrigger
     */
    kind: TriggerKind;
    /**
     * Action to be executed when trigger happens.
     * @type {WorkflowAction}
     * @memberof ConversationCreatedTrigger
     */
    action: WorkflowAction | null;
}



/**
 * Check if a given object implements the ConversationCreatedTrigger interface.
 */
export function instanceOfConversationCreatedTrigger(value: object): value is ConversationCreatedTrigger {
    if (!('kind' in value) || value['kind'] === undefined) return false;
    if (!('action' in value) || value['action'] === undefined) return false;
    return true;
}

export function ConversationCreatedTriggerFromJSON(json: any): ConversationCreatedTrigger {
    return ConversationCreatedTriggerFromJSONTyped(json, false);
}

export function ConversationCreatedTriggerFromJSONTyped(json: any, ignoreDiscriminator: boolean): ConversationCreatedTrigger {
    if (json == null) {
        return json;
    }
    return {
        
        'kind': TriggerKindFromJSON(json['kind']),
        'action': WorkflowActionFromJSON(json['action']),
    };
}

export function ConversationCreatedTriggerToJSON(json: any): ConversationCreatedTrigger {
    return ConversationCreatedTriggerToJSONTyped(json, false);
}

export function ConversationCreatedTriggerToJSONTyped(value?: ConversationCreatedTrigger | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'kind': TriggerKindToJSON(value['kind']),
        'action': WorkflowActionToJSON(value['action']),
    };
}

